"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function NotFoundClientLogger() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        const fullPath =
            pathname + (searchParams?.toString() ? `?${searchParams}` : "");

        fetch("/api/log-404", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                path: fullPath,
                method: "GET",
                referer: document.referrer || null,
                time: new Date().toISOString(),
            }),
        }).catch((err) => console.error("log 404 failed", err));
    }, [pathname, searchParams]);

    return null;
}
